/**
 * HA-570 resend outcome.
 *
 * A queue with no printer mapped to it is skipped rather than failed — there is nowhere to send
 * the ticket, which is a configuration gap, not an error. The operator still has to be told,
 * because otherwise "Tickets resent to kitchen" is a lie for that queue.
 */
export interface ResendTicketsResponse {
	queuesDispatched: number;
	warnings: string[];
}

export const RESEND_SUCCESS = "Tickets resent to kitchen";

/**
 * Copy per the Operator UX Patterns doc — the queue is named, because "a queue has no printer" is
 * not actionable when a course fires to three of them.
 *
 * The backend returns prose warnings; the queue name is the part that matters, so it is extracted
 * where the wording is recognisable and the server's sentence is passed through when it is not.
 * That keeps a future backend rewording readable rather than silently unparsed.
 */
export function describeResendWarning(warning: string): string {
	const match = /^No printers are mapped to (.+?) —/.exec(warning);

	return match
		? `${match[1]} has no printer — this ticket won't print`
		: warning;
}
